import React from 'react';
import './ModalProductos.scss';

export default function ModalProductos({
  productosConImagen,
  productosSeleccionados,
  toggleSeleccionProducto,
  comprarProductos,
  cerrarModal
}) {
  const handleComprar = () => {
    comprarProductos(productosSeleccionados); // solo ejecuta la compra
    // No cerramos ni activamos "Nueva conversación" aquí
  };

  return (
    <div className="modal-productos-overlay">
      <div className="modal-productos">
        <h3>Productos recomendados</h3>
        <p className="modal-instruccion">
          Seleccione los productos que considere apropiados; todos han sido recomendados para su condición.
        </p>
        <ul className="productos-lista">
          {productosConImagen.map((producto, index) => (
            <li key={index} className="producto-item">
              <img
                src={producto.url}
                alt={`Imagen del producto ${producto.nombre}`}
                className="producto-imagen-pequena"
              />
              <label>
                <input
                  type="checkbox"
                  checked={productosSeleccionados.includes(producto.nombre)}
                  onChange={() => toggleSeleccionProducto(producto.nombre)}
                />
                <span>{producto.nombre}</span>
              </label>
            </li>
          ))}
        </ul>
        <div className="modal-botones">
          <button
            type="button"
            onClick={handleComprar}
            className="boton-comprar"
          >
            Ver detalles
          </button>
          <button
            type="button"
            onClick={cerrarModal} // aquí sí se activa "Nueva conversación"
            className="boton-cerrar"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}
